import mainstay from "../assets/img/Mainstay.png";
import nuefluence from "../assets/img/Nuefluence.png";
import syntric from "../assets/img/Syntric.png";
import mula from "../assets/img/Mula.png";
import gpt from "../assets/img/chatgpt.png";
import userChat from "../assets/img/user-chat.png";

import mainstayVid from "../assets/videos/Mainstay.webm";
import nuefluenceVid from "../assets/videos/Nuefluence.webm";
import syntricVid from "../assets/videos/syntric.webm";
import mulaVid from "../assets/videos/Mula.webm";
import gptVid from "../assets/videos/chatgpt.webm";
import userChatVid from "../assets/videos/user-chat.webm";

export const info = {
  name: "HASSAN CHAUDHARY",
  github: "https://github.com/hassannn456",
  linkedin: "https://www.linkedin.com/in/hassanchaudharyy/",
  upwork: "https://www.upwork.com/freelancers/~014c6fe73748110469",
  jobTitle: ["Web Developer", "Full Stack Developer", "Web Designer"],
  intro:
    "Full stack developer who possesses a deep understanding of the core elements required to craft robust and dynamic web applications. Experienced with building apps from scratch and working with teams on ongoing projects.",
  skillIntro:
    "My experience as an engineer allows me to create and implement innovative solutions to technical problems on both backend and frontend of an application without compromising aesthetics, accessibility and functionality.",
  skills: [
    {
      title: "Languages",
      skills: ["HTML", "CSS", "JQuery", "JavaScript", "TypeScript", "Python"],
    },
    {
      title: "Front End",
      skills: [
        "React",
        "React Native",
        "Next",
        "Svelte",
        "Redux",
        "MUI",
        "Bootstrap",
        "Tailwind",
      ],
    },
    {
      title: "Back End",
      skills: [
        "Node",
        "Express",
        "Nest",
        "FastAPI",
        "Mongoose",
        "Sequelize",
        "TypeORM",
      ],
    },
    {
      title: "Tools/Others",
      skills: [
        "Netlify",
        "Docker",
        "Agile",
        "SDLC",
        "Jira/Trello",
        "Git/Github",
        "Rest/GraphQL",
      ],
    },
  ],
  projectIntro:
    "In both remote and office settings, I have vast experience in teamwork and leadership. My expertise in UX research, product design, and product management helps me integrate into project teams and drive the product's growth.",
  projects: [
    {
      title: "MAINSTAY",
      imgUrl: mainstay,
      video: mainstayVid,
      url: "https://mainstay.com/",
      status: "Complete",
      sector: "CMS | Business",
      timeline: "3 Months",
      workType: "Contract",
      topics: [
        "TS",
        "React",
        "Redux",
        "Redux Toolkit",
        "Thunk",
        "MUI",
        "CI/CD",
        "Jira",
      ],
      description:
        "Investment products and services providing app for companies with AI chatbot",
    },
    {
      title: "USER CHAT",
      imgUrl: userChat,
      video: userChatVid,
      url: "https://user-chats.netlify.app",
      status: "Complete",
      sector: "Networking | Social Media",
      timeline: "1 Month",
      workType: "Contract",
      topics: ["JS", "React", "Redux", "Saga", "Tailwind"],
      description:
        "Connect with others and chat effortlessly with a user-friendly app.",
    },
    {
      title: "NEUFLUENCE",
      imgUrl: nuefluence,
      video: nuefluenceVid,
      url: "https://neufluence.com/",
      status: "Ongoing",
      sector: "Social Media | Marketing | Business",
      timeline: "3 Months",
      workType: "Contract",
      topics: [
        "TS",
        "NextJS",
        "MUI",
        "Firebase",
        "Firestore",
        "Meta GraphAPI",
        "Webhooks",
        "Agolio",
        "GCP",
        "S3",
        "Trello",
      ],
      description:
        "Micro-creator platform that helps you reach multicultural customers at scale.",
    },
    {
      title: "SYNTRIC AI",
      imgUrl: syntric,
      video: syntricVid,
      url: "http://syntric-web-prod.s3-website-us-east-1.amazonaws.com/",
      status: "Ongoing",
      sector: "AI | Machine Learning",
      timeline: "2 Months",
      workType: "Contract",
      topics: ["JS", "Python", "NextJS", "MUI", "FastAPI"],
      description:
        "AI tool to create pictures with a wide array of skin tone variations",
    },
    {
      title: "CHATGPT CLONE",
      imgUrl: gpt,
      video: gptVid,
      url: "https://clone-chat-gpt.netlify.app",
      status: "Complete",
      sector: "AI | ChatBot",
      timeline: "1 week",
      workType: "In-house",
      topics: ["JS", "React", "MUI", "Clerk", "Netlify"],
      description:
        "Experience the power of ChatGPT in our intuitive clone app.",
    },
    {
      title: "MULA-X",
      imgUrl: mula,
      video: mulaVid,
      url: "https://staging.mula-x.co/customer-console/tabs/login",
      status: "Complete",
      sector: "Fintech | CMS",
      timeline: "3 Months",
      workType: "In-house",
      topics: [
        "TS",
        "React",
        "Node",
        "Express",
        "MUI",
        "Apollo",
        "GraphQL",
        "TypeORM",
        "Postgre SQL",
        "Redis",
        "Docker",
        "Jira",
      ],
      description:
        "Fintech company internal team management app",
    },
  ],
};
